import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { notifyStockWarnings } from '../components/WarehouseStockWarnings';
import { extractStockWarnings, responsePayload } from '../utils/clinicalStock';
import { invalidateWarehouseStock } from './useWarehouseProductMutations';

/**
 * After any clinical write that may move stock: refresh what the Warehouse
 * shows, and tell the professional about every shortage the write left.
 * Takes the mutation's Axios response as `onSuccess` receives it.
 */
export function useStockWriteFeedback(): (response: unknown) => void {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  return useCallback(
    (response: unknown) => {
      invalidateWarehouseStock(queryClient);
      notifyStockWarnings(
        enqueueSnackbar,
        extractStockWarnings(responsePayload(response)),
      );
    },
    [enqueueSnackbar, queryClient],
  );
}
